import { render } from "./QRReader.vue?vue&type=template&id=2d8af1b5&scoped=true"
import script from "./QRReader.vue?vue&type=script&lang=js"
export * from "./QRReader.vue?vue&type=script&lang=js"

import "./QRReader.vue?vue&type=style&index=0&id=2d8af1b5&scoped=true&lang=css"

import exportComponent from "D:\\projects\\wmsapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8af1b5"]])

export default __exports__